export const ORDER_OUT_GET_REQUEST = "ORDER_OUT_GET_REQUEST";
export const ORDER_OUT_GET_SUCCESS = "ORDER_OUT_GET_SUCCESS";
export const ORDER_OUT_GET_ERROR = "ORDER_OUT_GET_ERROR";

export const ORDER_IN_GET_REQUEST = "ORDER_IN_GET_REQUEST";
export const ORDER_IN_GET_SUCCESS = "ORDER_IN_GET_SUCCESS";
export const ORDER_IN_GET_ERROR = "ORDER_IN_GET_ERROR";

export const ORDER_ADD_REQUEST = "ORDER_ADD_REQUEST";
export const ORDER_ADD_SUCCESS = "ORDER_ADD_SUCCESS";
export const ORDER_ADD_ERROR = "ORDER_ADD_ERROR";
export const ORDER_PAY_SUCCESS = "ORDER_PAY_SUCCESS";

export const ORDER_PAYMENT_REQUEST = "ORDER_PAYMENT_REQUEST";
export const ORDER_PAYMENT_SUCCESS = "ORDER_PAYMENT_SUCCESS";
export const ORDER_PAYMENT_ERROR = "ORDER_PAYMENT_ERROR";

export const ORDER_UPDATE_REQUEST = "ORDER_UPDATE_REQUEST";
export const ORDER_UPDATE_SUCCESS = "ORDER_UPDATE_SUCCESS";
export const ORDER_UPDATE_ERROR = "ORDER_UPDATE_ERROR";

export const ORDER_DELIVER_REQUEST = "ORDER_DELIVER_REQUEST";
export const ORDER_DELIVER_SUCCESS = "ORDER_DELIVER_SUCCESS";
export const ORDER_DELIVER_FAIL = "ORDER_DELIVER_FAIL";
export const ORDER_DELIVER_RESET = "ORDER_DELIVER_RESET";

export const ORDER_SINGLE_REQUEST = "ORDER_SINGLE_REQUEST";
export const ORDER_SINGLE_SUCCESS = "ORDER_SINGLE_SUCCESS";
export const ORDER_SINGLE_ERROR = "ORDER_SINGLE_ERROR";
